export const featureFlags = {
    bl174Portal: process.env.REACT_APP_BL174_PORTAL === 'true',
    bl362ClientOnboardingPreview:
        process.env.REACT_APP_BL362_CLIENT_ONBOARDING_PREVIEW === 'true',
};
